import {BgTransService} from '../core/services'

export class AppBgTransService extends BgTransService {}
